import { DEFAULT_SLIPPAGE } from '@ui/constants/uiConfig';

import { formatSlippage } from '../utils/formatSlippage';
import { createPersistValue } from './createPersistValue';

export const useSlippageValue = createPersistValue<number>(
  'trade.slippage',
  DEFAULT_SLIPPAGE,
  1,
); // 0.005 * 100% = 0.5%

export const useSlippage = () => {
  const persistValue = useSlippageValue((s) => s._persistValue);
  
return formatSlippage(persistValue);
};
